import React, { PropsWithChildren, useReducer } from "react"
import { DashboardContext } from "./context"
import { dashboardContextReducer, initialState } from "./reducer"

export const DashboardContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [state, dispatch] = useReducer(dashboardContextReducer, initialState)

	return <DashboardContext.Provider value={[state, dispatch]}>{children}</DashboardContext.Provider>
}
